import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  CardMedia,
  IconButton,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Image from '../Images/UlapRecPictures/1.jpg';
import { ArrowBackIos, ArrowForwardIos } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  backgroundBox: {
    backgroundColor: '#FFD6B4',
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
    },
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
  },
  highlight: {
    color: '#FF7707',
  },
  title: {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      fontSize: '2rem',
    },
    [theme.breakpoints.down('sm')]: {
        textAlign: 'left',
      fontSize: '25px',
    },
  },
  carouselWrapper: {
    position: 'relative',
    overflow: 'hidden',
  },
  cardRow: {
    display: 'flex',
    transition: 'transform 0.5s ease-in-out',
  },
  cardRowNoTransition: {
    transition: 'none',
  },
  card: {
    minWidth: '300px',
    maxWidth: '300px',
    marginRight: theme.spacing(2),
    backgroundColor: '#fff7f0',
    boxShadow: theme.shadows[3],
    flexShrink: 0,
  },
  media: {
    height: 300,
    backgroundSize: 'cover',
  },
  cardTitle: {
    fontWeight: 'bold',
    fontSize: '1.25rem',
    marginBottom: theme.spacing(1),
    color: '#FF7707',
  },
  cardDesc: {
    fontSize: '0.95rem',
    color: '#333',
  },
  navButton: {
    position: 'absolute',
    top: '40%',
    transform: 'translateY(-50%)',
    zIndex: 1,
    backgroundColor: '#ffffffaa',
    '&:hover': {
      backgroundColor: '#ffffff',
    },
  },
  leftArrow: {
    left: 0,
  },
  rightArrow: {
    right: 0,
  },
}));

function Features() {
  const classes = useStyles();
  const visibleCards = 3;
  const featureData = [
    { title: 'AUTOMATED JOB POSTING AND SCREENING', description: 'Find the best candidate faster.' },
    { title: 'INTERVIEW SCHEDULING', description: 'No more back-and-forth emails.' },
    { title: 'DIGITAL ONBOARDING', description: 'Company policies, training, and guidelines in one place.' },
    { title: 'AI- POWERED SKILL DEVELOPMENT', description: 'Boost employee productivity with tailored training.' },
    { title: 'WORKLOAD REDUCTION', description: 'Automate repetitive tasks and save hours.' },
  ];

  const [currentIndex, setCurrentIndex] = useState(visibleCards);
  const [transitioning, setTransitioning] = useState(true);
  const containerRef = useRef(null);
  const totalSlides = featureData.length;

  // Clone start and end
  const extendedSlides = [
    ...featureData.slice(-visibleCards),
    ...featureData,
    ...featureData.slice(0, visibleCards),
  ];

  const cardWidth = 300 + 16; 

  const handleNext = () => {
    setCurrentIndex((prev) => prev + 1);
    setTransitioning(true);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => prev - 1);
    setTransitioning(true);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 3000);

    return () => clearInterval(interval);
  }, []);

 
  const handleTransitionEnd = () => {
    if (currentIndex === totalSlides + visibleCards) {
      setTransitioning(false);
      setCurrentIndex(visibleCards);
    }
    if (currentIndex === 0) {
      setTransitioning(false);
      setCurrentIndex(totalSlides);
    }
  };

  useEffect(() => {
    if (!transitioning) {
      requestAnimationFrame(() => {
        setTransitioning(true);
      });
    }
  }, [transitioning]);

  return (
    <Box className={classes.backgroundBox}>
      <Container>
        <Typography className={classes.title}>
          HIRE WITHOUT THE <span className={classes.highlight}>HASSLE</span>
        </Typography>

        <div className={classes.carouselWrapper}>
          <IconButton
            className={`${classes.navButton} ${classes.leftArrow}`}
            onClick={handlePrev}
          >
            <ArrowBackIos />
          </IconButton>

          <IconButton
            className={`${classes.navButton} ${classes.rightArrow}`}
            onClick={handleNext}
          >
            <ArrowForwardIos />
          </IconButton>

          <div
            ref={containerRef}
            className={`${classes.cardRow} ${
              !transitioning ? classes.cardRowNoTransition : ''
            }`}
            style={{
              transform: `translateX(-${currentIndex * cardWidth}px)`,
            }}
            onTransitionEnd={handleTransitionEnd}
          >
            {extendedSlides.map((feature, index) => (
              <Card className={classes.card} key={index}>
                <CardMedia
                  className={classes.media}
                  image={Image}
                  title={feature.title}
                />
                <CardContent>
                  <Typography className={classes.cardTitle}>
                    {feature.title}
                  </Typography>
                  <Typography className={classes.cardDesc}>
                    {feature.description}
                  </Typography>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </Container>
    </Box>
  );
}

export default Features;
